import { Button, Col, Form, Image, Input, message, Row, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IconLeft } from '@assets';
import { CheckOutlined, CloseCircleFilled } from '@ant-design/icons';
import { IconUploadImage } from '../../../../../assets/icons';
import { useNavigate } from 'react-router-dom';
import api from '../../../../../api/api';
import { useTranslation } from 'react-i18next';

const RootContainer = styled.div`
position: relative;

.ant-form {

.buttons-wrapper {
  position: absolute;
  top: -70px;
  right: 12px;
}

.ant-btn {
height: 48px;
width: 172px;
}
}
`;

const Topbar = styled.div`
padding-top: 16px;
padding-bottom: 24px;
display: flex;
gap: 18px;
align-items: center;
justify-content: center;

.ant-btn-default {
    height: 48px;
    padding: 0 12px !important;
    border: none !important;
    background: ${props => props.theme.backgroundColor} !important;
    color: ${props => props.theme.primaryColor} !important;
}

.ant-btn-primary {
    width: 172px;
    height: 48px;
}
`;

const TitleWrapper = styled.div`
flex: 1;
display: flex;
align-items: center;
justify-content: flex-start;
gap: 10px;
`;

const Title = styled.div`
font-size: 18px;
font-weight: 400;
color: #1D1014;
line-height: 1;
`;

const GrayTitle = styled(Title)`
color: #868686;
`;

const UploadWrapper = styled.div`
width: 100%;
padding: 20px;
display: flex;
gap: 16px;
flex-direction: column;
align-items: flex-start;
justify-content: center;
border-radius: 8px;
background-color: ${props => props.theme.backgroundColor};

label {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
`;

const LightText = styled.div`
font-size: 16px;
font-weight: 400;
color: #868686;
line-height: 1.5;
`;

const GrayText = styled.div`
font-size: 14px;
font-weight: 400;
color: #B9B9B9;
white-space: pre-wrap;
text-align: center;
`;

const Box = styled.div`
width: 70%;
height: auto;
aspect-ratio: 1;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 9px;
background-color: #fff;
border-radius: 8px;
border: 1px solid #B9B9B9;
cursor: pointer;
position: relative;

.anticon {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 32px;
  color: #868686;
}
`;

const R = styled.div`
font-size: 16px;
font-weight: 400;
color: #E12727;
`;


/** --- UploadLogoBox --- */
const UploadLogoBox = React.memo(({ file, onFileChange, onRemove }) => {
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null);
      return;
    }
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const {t} = useTranslation();

  return (
    <UploadWrapper>
      <Space size="small">
        <LightText>{t('payment_logo')}</LightText>
        <R>*</R>
      </Space>
      <label htmlFor="file-input">
        <Box>
          {previewUrl ? (
            <Image src={previewUrl} preview={false} />
          ) : (
            <>
              <IconUploadImage />
              <GrayText>{t('upload_file_or_drag')}</GrayText>
            </>
          )}
          {file && <CloseCircleFilled onClick={onRemove} />}
        </Box>
      </label>
      <input
        id="file-input"
        type="file"
        disabled={!!file}
        hidden
        onChange={onFileChange}
      />
      <LightText style={{ textAlign: 'center' }}>
        {t('image_limit_payment')}
      </LightText>
    </UploadWrapper>
  );
});


/** --- UploadQrBox --- */
const UploadQrBox = React.memo(({ file, onFileChange, onRemove }) => {
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null);
      return;
    }
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const {t} = useTranslation();


  return (
    <UploadWrapper>
      <Space size="small">
        <LightText>{t('payment_qr_image')}</LightText>
        <R>*</R>
      </Space>
      <label htmlFor="file-input-2">
        <Box>
          {previewUrl ? (
            <Image src={previewUrl} preview={false} />
          ) : (
            <>
              <IconUploadImage />
              <GrayText>{t('upload_file_or_drag')}</GrayText>
            </>
          )}
          {file && <CloseCircleFilled onClick={onRemove} />}
        </Box>
      </label>
      <input
        id="file-input-2"
        type="file"
        disabled={!!file}
        hidden
        onChange={onFileChange}
      />
      <LightText style={{ textAlign: 'center' }}>
       {t('image_limit_payment')}
      </LightText>
    </UploadWrapper>
  );
});

const AddPaymentMethod = () => {
    const navigate = useNavigate();
    const [fileLogo, setFileLogo] = useState(null);
    const [fileQr, setFileQr] = useState(null);
    const [disabledSave, setDisabledSave] = useState(true);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [formValues, setFormValues] = useState(null);
    const [form] = Form.useForm();

    const {t} = useTranslation();

    useEffect(() => {
        if (Object.keys(uploadedFiles).length === 2) {
            doPost();
        }
        // eslint-disable-next-line
    }, [uploadedFiles]);

    const handleFileLogoChange = (e) => {
        if (e.target.files.length === 0) {
            return;
        }
        setFileLogo(e.target.files[0]);
    }

    const handleRemoveLogoClicked = e => {
        e.preventDefault();
        e.stopPropagation();
        setFileLogo(null);
    }

    const handleFileQrChange = (e) => {
        if (e.target.files.length === 0) {
            return;
        }
        setFileQr(e.target.files[0]);
    }

    const handleRemoveQrClicked = e => {
        e.preventDefault();
        e.stopPropagation();
        setFileQr(null);
    }

    const onFieldsChange = (changedFields, allFields) => {
        setDisabledSave(
            allFields.find(field => field.value === undefined || field.value === "")
        );
    }

    const successCallback = () => {
        goBack();
    }

    const doPost = () => {
        let { payment_name, payment_acc_no, payment_acc_name } = formValues;
        let payload = {
            is_active: true,
            payment_name: payment_name.trim(),
            payment_acc_name: payment_acc_name.trim(),
            payment_acc_no: payment_acc_no.trim(),
            ...uploadedFiles,
        };
        api
            .createPayment(payload)
            .then(() => {
                setConfirmLoading(false);
                message.success(t('success'));
                successCallback();
            })
            .catch(error => {
                setConfirmLoading(false);
                message.error(error);
            });
    }

    const uploadImage = (file, key) => {
        api
            .uploadMedia({
                file,
                file_path: file.type,
            })
            .then(({ data: { url } }) => {
                setUploadedFiles(prev => {
                    return {
                        ...prev,
                        [key]: url,
                    }
                });
            })
            .catch(error => {
                setConfirmLoading(false);
                message.error(error);
            });
    }

    const onFinish = (values) => {
        if (!confirmLoading) {
            if (values.payment_acc_no.trim() !== values.confirm_payment_acc_no.trim()) {
                message.error(t('account_not_match'));
                return;
            }
            setConfirmLoading(true);
            setFormValues(values);
            uploadImage(fileLogo, 'payment_logo');
            uploadImage(fileQr, 'payment_qr');
        }
    }

    const goBack = () => {
        navigate(-1);
    }

    // const UploadLogoBox = () => (
    //     <UploadWrapper>
    //         <Space size={'small'}>
    //             <LightText>Payment Method Logo</LightText>
    //             <R>*</R>
    //         </Space>
    //         <label htmlFor='file-input'>
    //             <Box>
    //                 {fileLogo
    //                     ? <Image src={URL.createObjectURL(fileLogo)} preview={false} />
    //                     : <>
    //                         <IconUploadImage />
    //                         <GrayText>{`Upload image or \n drop a file`}</GrayText>
    //                     </>
    //                 }
    //                 {fileLogo && <CloseCircleFilled onClick={handleRemoveLogoClicked} />}
    //             </Box>
    //         </label>
    //         <input
    //             id='file-input'
    //             type='file'
    //             disabled={fileLogo}
    //             hidden onChange={handleFileLogoChange}
    //         />
    //         <LightText style={{ textAlign: 'center' }}>500 px * 500 px,  PNG, JPG, Up to 2 MB</LightText>
    //     </UploadWrapper>
    // );

    // const UploadQrBox = () => (
    //     <UploadWrapper>
    //         <Space size={'small'}>
    //             <LightText>Payment Method QR Image</LightText>
    //             <R>*</R>
    //         </Space>
    //         <label htmlFor='file-input-2'>
    //             <Box>
    //                 {fileQr
    //                     ? <Image src={URL.createObjectURL(fileQr)} preview={false} />
    //                     : <>
    //                         <IconUploadImage />
    //                         <GrayText>{`Upload image or \n drop a file`}</GrayText>
    //                     </>
    //                 }
    //                 {fileQr && <CloseCircleFilled onClick={handleRemoveQrClicked} />}
    //             </Box>
    //         </label>
    //         <input
    //             id='file-input-2'
    //             type='file'
    //             disabled={fileQr}
    //             hidden onChange={handleFileQrChange}
    //         />
    //         <LightText style={{ textAlign: 'center' }}>500 px * 500 px,  PNG, JPG, Up to 2 MB</LightText>
    //     </UploadWrapper>
    // );

    return (
        <RootContainer>
            <Topbar>
                <Button
                    type='default'
                    icon={<IconLeft />}
                    onClick={goBack}
                >
                    {t('back')}
                </Button>
                <TitleWrapper>
                    <GrayTitle>{t('payment_method')}</GrayTitle>
                    <GrayTitle>{`>`}</GrayTitle>
                    <Title>{t('add_manual_payment_method')}</Title>
                </TitleWrapper>
            </Topbar>
            <Row gutter={24}>
                <Col xs={8}>
                    {/* <UploadLogoBox /> */}
                     <UploadLogoBox
            file={fileLogo}
            onFileChange={handleFileLogoChange}
            onRemove={handleRemoveLogoClicked}
          />
                </Col>
                <Col xs={8}>
                    {/* <UploadQrBox /> */}
                     <UploadQrBox
            file={fileQr}
            onFileChange={handleFileQrChange}
            onRemove={handleRemoveQrClicked}
          />
                </Col>
                <Col xs={8}>
                    <Form
                        form={form}
                        layout='vertical'
                        // initialValues={{
                        //     payment_name: data.payment_name,
                        //     payment_acc_name: data.payment_acc_name,
                        //     payment_acc_no: data.payment_acc_no,
                        //     confirm_payment_acc_no: data.confirm_payment_acc_no,
                        // }}
                        onFieldsChange={onFieldsChange}
                        onFinish={onFinish}
                    >
                        <Form.Item className='buttons-wrapper'>
                            <Button
                                type='primary'
                                htmlType='submit'
                                disabled={!fileLogo || !fileQr || disabledSave}
                                loading={confirmLoading}
                                icon={<CheckOutlined />}
                            >
                                {t('save')}
                            </Button>
                        </Form.Item>
                        <Form.Item
                            name={"payment_name"}
                            // label="Payment Method Name"
                            rules={[{
                                required: true,
                                message: ""
                            }]}
                        >
                            <Input placeholder={t('payment_method_name')} />
                        </Form.Item>
                        <Form.Item
                            name={"payment_acc_name"}
                            // label="Payment Account Name"
                            rules={[{
                                required: true,
                                message: ""
                            }]}
                        >
                            <Input placeholder={t('payment_acc_name')} />
                        </Form.Item>
                        <Form.Item
                            name={"payment_acc_no"}
                            // label="Payment Account or Phone Number"
                            rules={[{
                                required: true,
                                message: ""
                            }]}
                        >
                            <Input placeholder={t('payment_acc_name_number')} />
                        </Form.Item>
                        <Form.Item
                            name={"confirm_payment_acc_no"}
                            // label="Confirm Payment Account or Phone Number"
                            rules={[{
                                required: true,
                                message: ""
                            }]}
                        >
                            <Input placeholder={t('payment_acc_name_number_confirm')} />
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </RootContainer>
    )
}

export default AddPaymentMethod